"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _wedding = require("@/api/wedding");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Promotions',
  data: function data() {
    return {
      picObj: {
        'TB': require('@/assets/platformIcon/tb.png'),
        'JD': require('@/assets/platformIcon/jd.png'),
        'PDD': require('@/assets/platformIcon/pdd.png'),
        'WPH': require('@/assets/platformIcon/wph.png')
      },
      activityOption: [],
      rules: {
        activityId: [{
          required: true,
          message: '请选择所属活动',
          trigger: 'change'
        }],
        stockAdjustType: [{
          required: true,
          message: '请选择调整方式',
          trigger: 'change'
        }],
        stockTotal: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        stockAdjustQty: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        giftAmt: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        sortNo: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        goodsCommand: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }]
      },
      dialogVisible: false,
      eventsType: '',
      ruleForm: {
        operateType: '',
        id: null,
        platformCode: 'TB',
        goodsCommand: '',
        activityId: '',
        goodsId: '',
        goodsPic: '',
        title: '',
        originPrice: '',
        couponPrice: '',
        stockTotal: '',
        giftAmt: '',
        sortNo: '',
        goodsStatus: 1,
        stockAdjustType: '',
        stockAdjustQty: ''
      },
      realObj: {
        0: '#E6A23C',
        1: '#67C23A',
        2: '#F56C6C'
      },
      queryData: {
        title: '',
        goodsStatus: 1,
        activityIdList: '',
        page: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      balanceAmt: '',
      giftSendAmt: '',
      giftSendCount: '',
      title: '',
      stockTotal: '',
      stockRemain: '',
      id: ''
    };
  },
  created: function created() {
    this.findMod();
    this.findSelect();
    this.activityList();
  },
  methods: {
    allChange: function allChange(val) {
      var _this = this;
      console.log(val);
      this.$confirm(val.goodsStatus === 1 ? '是否确认上架该商品?' : '是否确认下架该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _wedding.change_goods)({
          operateType: 3,
          id: val.id,
          goodsStatus: val.goodsStatus
        }).then(function (res) {
          if (res.data) {
            _this.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
            _this.activityList();
          }
        });
      }).catch(function () {
        if (val['goodsStatus'] === 1) {
          val['goodsStatus'] = 0;
        } else {
          val['goodsStatus'] = 1;
        }
      });
    },
    copy: function copy(val) {
      var _this2 = this;
      this.$copyText(val).then(function () {
        _this2.$notify.success({
          title: '温馨提示',
          message: '拷贝成功'
        });
      }).catch(function () {
        _this2.$notify.success({
          title: '温馨提示',
          message: '拷贝失败，请手动复制'
        });
      });
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.$confirm("".concat(_this3.eventsType === 'add' ? '是否确认添加此商品?' : _this3.eventsType === 'upDate' ? '是否确认编辑此商品?' : '是否确认进行库存调整?'), '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            var obj = {
              'add': 1,
              'upDate': 2,
              'stock': 4
            };
            _this3.ruleForm['operateType'] = obj[_this3.eventsType];
            _this3.ruleForm['id'] = _this3.id;
            (0, _wedding.change_goods)(_this3.ruleForm).then(function (res) {
              if (res.data) {
                _this3.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                _this3.handleClose();
                _this3.onInquire();
              }
            });
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.initRuleForm();
      this.$refs[formName].resetFields();
    },
    findSelect: function findSelect() {
      var _this4 = this;
      (0, _wedding.get_select)({}).then(function (res) {
        _this4.activityOption = res.data;
      });
    },
    findGoods: function findGoods() {
      var _this5 = this;
      (0, _wedding.searchGoods)({
        keyword: this.ruleForm.goodsCommand
      }).then(function (res) {
        if (res.data && res.data.itemList.length > 0) {
          _this5.ruleForm.goodsId = res.data.itemList[0].id;
          _this5.ruleForm.goodsPic = res.data.itemList[0].picUrl;
          _this5.ruleForm.title = res.data.itemList[0].title;
          _this5.ruleForm.originPrice = res.data.itemList[0].orgPrice;
          _this5.ruleForm.couponPrice = res.data.itemList[0].actualPrice;
        } else {
          _this5.$message.error('未查询到有效商品信息，请检查后再试');
        }
      });
    },
    onAdd: function onAdd() {
      this.eventsType = 'add';
      this.initRuleForm();
      this.ruleForm.operateType = 1;
      this.id = null;
      this.dialogVisible = true;
    },
    changeStock: function changeStock(val) {
      var _this6 = this;
      (0, _wedding.query_goods)({
        id: val.id
      }).then(function (res) {
        _this6.eventsType = 'stock';
        _this6.initRuleForm();
        res.data['stockAdjustType'] = '';
        res.data['stockAdjustQty'] = '';
        _this6.id = res.data.id;
        _this6.title = res.data.title;
        _this6.stockTotal = res.data.stockTotal;
        _this6.stockRemain = res.data.stockRemain;
        _this6.ruleForm = (0, _objectSpread2.default)({}, res.data);
        _this6.ruleForm.operateType = 4;
        _this6.dialogVisible = true;
      });
    },
    detail: function detail(val) {
      var _this7 = this;
      (0, _wedding.query_goods)({
        id: val.id
      }).then(function (res) {
        _this7.eventsType = 'upDate';
        _this7.initRuleForm();
        _this7.id = res.data.id;
        _this7.ruleForm = (0, _objectSpread2.default)({}, res.data);
        _this7.ruleForm.operateType = 2;
        _this7.dialogVisible = true;
      });
    },
    handleClose: function handleClose() {
      this.initRuleForm();
      this.resetForm('ruleForm');
      this.dialogVisible = false;
    },
    initRuleForm: function initRuleForm() {
      // this.id = ''
      // this.title = ''
      // this.stockTotal = ''
      // this.stockRemain = ''
      this.ruleForm = {
        operateType: '',
        id: null,
        platformCode: 'TB',
        goodsCommand: '',
        activityId: '',
        goodsId: '',
        goodsPic: '',
        title: '',
        originPrice: '',
        couponPrice: '',
        stockTotal: '',
        giftAmt: '',
        sortNo: '',
        goodsStatus: 1,
        stockAdjustType: '',
        stockAdjustQty: ''
      };
    },
    findMod: function findMod() {
      var _this8 = this;
      (0, _wedding.getAll)().then(function (res) {
        _this8.balanceAmt = res.data.balanceAmt;
        _this8.giftSendAmt = res.data.giftSendAmt;
        _this8.giftSendCount = res.data.giftSendCount;
      });
    },
    del: function del(val) {
      var _this9 = this;
      this.$confirm('是否确认删除此商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _wedding.del_goods)({
          id: val.id
        }).then(function (res) {
          if (res.data) {
            _this9.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
            _this9.activityList();
          }
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.activityList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.activityList();
    },
    activityList: function activityList() {
      var _this0 = this;
      (0, _wedding.get_goods)(this.queryData).then(function (res) {
        _this0.total = res.data.total;
        _this0.tableData = res.data.data;
      });
    },
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.activityList();
    },
    initQueryData: function initQueryData() {
      this.queryData = {
        title: '',
        goodsStatus: 1,
        page: 1,
        size: 10,
        activityIdList: ''
      };
    },
    onInitialize: function onInitialize() {
      this.initQueryData();
      this.activityList();
    }
  }
};